import {Injectable} from '@angular/core';
import {Socket} from 'ngx-socket-io';
import {notificationServer} from './notifications-server-configuration';

@Injectable({
  providedIn: 'root'
})
export class DocumentRequestSocketService extends Socket {
  constructor() {
    const url = notificationServer.url + '/documentRequest';
    super({url: url, options: {}});
  }
}
